export default __webpack_public_path__ + "static/media/edit-white.8811bc23.svg";